export const lenisPreventCheck = (node: HTMLElement) =>
  ('prevent' in node.dataset && node.dataset.prevent === 'lenis') ||
  'nextjsDialogOverlay' in node.dataset;
